export const selectIframePage = (state: RootState) => state.iframe.iframePage
